import { getInternalShowingDetailsUrl } from 'utils';
import { defer } from 'lodash';

const bbInternalFeedbackComponent = {
  bindings: {},
  controller: InternalFeedbackController,
  controllerAs: 'vm',
  template: require('./internal_feedback.html'),
};

InternalFeedbackController.$inject = [
  'AppointmentBookService',
  'ErrorService',
  'FeedbackService',
  '$scope',
  '$routeParams',
  '$location',
  '$rootScope',
];

function InternalFeedbackController(
  AppointmentBookService,
  ErrorService,
  FeedbackService,
  $scope,
  $routeParams,
  $location,
  $rootScope,
) {
  const vm = this;

  vm.$onInit = () => {
    vm.loading = true;
    vm.submitDisabled = true;
    vm.appointmentId = $routeParams.appointmentId;

    vm.cancelUrl = `/#${getInternalShowingDetailsUrl(vm.appointmentId)}`;

    // Get feedback template elements
    AppointmentBookService.getAppointmentAndListingForCoop(
      $routeParams.appointmentId,
    )
      .then(({ listing }) => {
        vm.listing = listing;

        return FeedbackService.getFeedbackForCoop(
          $routeParams.appointmentId,
          vm.listing.id,
        );
      })
      .then(({ id, template }) => {
        vm.id = id;
        vm.template = template;
      })
      .catch(err => {
        ErrorService.toastyHTTPErr(err);
      })
      .finally(() => {
        vm.loading = false;
      });
  };

  vm.onResponseChange = (index, response) => {
    vm.template[index] = { ...vm.template[index], response };
    vm.submitDisabled = !vm.template.some(template => !!template.response);
    defer(() => $scope.$apply());
  };

  vm.submitFeedback = () => {
    vm.loading = true;
    const feedback = {
      id: vm.id,
      contactId: $rootScope.auth.id,
      template: vm.template,
    };

    FeedbackService.saveFeedbackByCoop(
      $routeParams.appointmentId,
      vm.listing.id,
      feedback,
    )
      .then(() => {
        swal(
          {
            title: `Feedback Submitted!`,
            html: true,
            type: 'success',
          },
          () => {
            $scope.$apply(() => {
              $location.path(
                getInternalShowingDetailsUrl($routeParams.appointmentId),
              );
            });
          },
        );
      })
      .catch(err => {
        vm.loading = false;
        ErrorService.toastyHTTPErr(err);
      });
  };
}

export default bbInternalFeedbackComponent;
